/* Filo Finds — engagement.js  (wishlist + recently viewed + share hooks) */

(() => {
  "use strict";
  const $  = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  const WISHLIST_KEY = "ff_wishlist";
  const RECENT_KEY   = "ff_recently_viewed";

  // ---------- Wishlist -----------------------------------------------------
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || "[]"); } catch { return []; }
  }
  function setWishlist(list) { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); }

  function syncToggle(btn) {
    const handle = btn.dataset.productHandle;
    const on = getWishlist().includes(handle);
    btn.classList.toggle("is-on", on);
    btn.setAttribute("aria-pressed", String(on));
  }

  function bindWishlistButtons(root = document) {
    $$("[data-wishlist-toggle]", root).forEach(btn => {
      syncToggle(btn);
      if (btn.dataset.bound) return;
      btn.dataset.bound = "1";
      btn.addEventListener("click", (e) => {
        e.preventDefault(); e.stopPropagation();
        const handle = btn.dataset.productHandle;
        let list = getWishlist();
        list = list.includes(handle) ? list.filter(h => h !== handle) : [handle, ...list];
        setWishlist(list);
        $$("[data-wishlist-toggle][data-product-handle='" + handle + "']").forEach(syncToggle);
        document.dispatchEvent(new CustomEvent("wishlist:change"));
      });
    });
  }
  bindWishlistButtons();

  // ---------- Wishlist page hydration --------------------------------------
  async function renderWishlistPage() {
    const root = $("[data-wishlist-page]");
    if (!root) return;
    const list = getWishlist();
    const countEl = $("[data-wishlist-count]", root);
    const ul = $("[data-wishlist-list]", root);
    const empty = $("[data-wishlist-empty]", root);

    countEl.textContent = `${list.length} item${list.length === 1 ? "" : "s"}`;
    if (!list.length) { empty.hidden = false; return; }
    empty.remove();

    const html = await Promise.all(list.map(async (handle) => {
      try {
        const p = await fetch(`/products/${handle}.js`).then(r => r.ok ? r.json() : null);
        if (!p) return "";
        const img = p.featured_image ? `<img src="${p.featured_image}" alt="" loading="lazy">` : "";
        const price = p.price_min === p.price_max
          ? formatMoney(p.price)
          : `From ${formatMoney(p.price_min)}`;
        return `<li>
          <a class="card-product" href="${p.url}">
            <div class="card-product__media">${img}</div>
            <h3 class="card-product__title">${p.title}</h3>
            <div class="card-product__price">${price}</div>
          </a>
          <button class="wishlist-remove" data-wishlist-remove="${handle}">Remove</button>
        </li>`;
      } catch { return ""; }
    }));
    ul.innerHTML = html.join("");
    $$("[data-wishlist-remove]", ul).forEach(btn => {
      btn.addEventListener("click", () => {
        const h = btn.dataset.wishlistRemove;
        setWishlist(getWishlist().filter(x => x !== h));
        renderWishlistPage();
      });
    });
  }
  function formatMoney(cents) {
    return (cents / 100).toLocaleString(undefined, { style: "currency", currency: window.Shopify?.currency?.active || "CAD" });
  }
  renderWishlistPage();
  document.addEventListener("wishlist:change", renderWishlistPage);

  // ---------- Recently viewed ---------------------------------------------
  async function renderRecentlyViewed() {
    const sec = $("[data-recently-viewed]");
    if (!sec) return;
    let list = [];
    try { list = JSON.parse(localStorage.getItem(RECENT_KEY) || "[]"); } catch {}
    const currentId = $("[data-product-id]")?.dataset.productId;
    if (currentId) list = list.filter(id => String(id) !== String(currentId));
    list = list.slice(0, 8);
    if (!list.length) return;

    // recently-viewed stores product IDs; we need product info → fetch each
    // via /products.json?ids=… isn't a route, so fetch each handle isn't possible from ID alone.
    // Instead, opportunistically capture handle alongside ID in theme.js (already done for /products/<handle>).
    // For now, capture handles on next visit. If we have handles only, render; otherwise fallback.
    const handles = list.filter(x => typeof x === "string" && !/^\d+$/.test(x));
    if (!handles.length) return;

    const cards = await Promise.all(handles.map(async (h) => {
      try {
        const p = await fetch(`/products/${h}.js`).then(r => r.ok ? r.json() : null);
        if (!p) return "";
        const img = p.featured_image ? `<img src="${p.featured_image}" alt="" loading="lazy">` : "";
        const price = p.price_min === p.price_max
          ? formatMoney(p.price)
          : `From ${formatMoney(p.price_min)}`;
        return `<li><a class="card-product" href="${p.url}">
          <div class="card-product__media">${img}</div>
          <h3 class="card-product__title">${p.title}</h3>
          <div class="card-product__price">${price}</div>
        </a></li>`;
      } catch { return ""; }
    }));
    const valid = cards.filter(Boolean);
    if (!valid.length) return;
    $("[data-recently-viewed-list]", sec).innerHTML = valid.join("");
    sec.hidden = false;
  }
  renderRecentlyViewed();

  // ---------- Capture recently-viewed by HANDLE (more useful than ID) -----
  try {
    // The product page exposes `data-product-handle` via wishlist-button; piggy-back to capture handle.
    const handle = $("[data-product-handle]")?.dataset.productHandle;
    if (handle) {
      let list = [];
      try { list = JSON.parse(localStorage.getItem(RECENT_KEY) || "[]"); } catch {}
      list = [handle, ...list.filter(x => x !== handle)].slice(0, 12);
      localStorage.setItem(RECENT_KEY, JSON.stringify(list));
    }
  } catch {}
})();
